$(document).on("turbolinks:load", function(){
  $(document).ready(function () {
    $.validator.addMethod("nameregex", function(value, element, regexpr) {          
      return regexpr.test(value);
    });
    $('form.new_form_aplicant').each(function(key, form) {
      $(form).validate({
        rules: {
          "applicant[first_name]": {
            required: true,
            minlength: 2,
            maxlength: 40,
            nameregex: /^[a-zA-Z ]+$/
          },
          
          "applicant[last_name]": {
            required: true,
            minlength: 2,
            maxlength: 40,
            nameregex: /^[a-zA-Z ]+$/
          },

          "applicant[email]": {
            required: true,
            nameregex: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
          },

          "applicant[contact_number]": {
            required: true,
            nameregex: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
          },

          "applicant[message]": {
            required: true,
            minlength: 10,
            maxlength: 100,
            nameregex: /^[a-zA-Z ]+$/
          }
        },
        messages: {
          "applicant[first_name]": {
            required: 'The first name is required.',
            minlength: 'The first name must be 2-40 characters long.',
            maxlength: 'The first name must be 2-40 characters long.',
            nameregex: 'The first name can only consist of alphabets.'
          },
          "applicant[last_name]": {
            required: 'The last name is required.',
            minlength: 'The last name must be 2-40 characters long.',
            maxlength: 'The last name must be 2-40 characters long.',
            nameregex: 'The last name can only consist of alphabets.'
          },
          "applicant[email]": {
            required: 'The email is required.',
            nameregex: 'The email pattern must followed.'
            },
          "applicant[contact_number]": {
            required: 'The phone number is required.',
            minlength: 'minlength 10 digits are allowed.',
            nameregex: 'The phone contain only 10 digits.'
          },
          "applicant[message]": {
            required: 'The first name is required.',
            minlength: 'The message must be 10-100 characters long.',
            maxlength: 'The message must be 10-100 characters long.',
            nameregex: 'The message can only consist of alphabets.'
          }
        }
      });
    });
  });
});


  $(document).ready(function(){
    function CheckValue(val){
      var element=document.getElementById('otherText');
      if(val=='Select option'||val=='Others'){
        element.style.display='block';
      }
      else{
        element.style.display='none';
      }
    }
    $("#applicant_purpose").change(function(){
      CheckValue(this.value)
    });
  });